const wystawca = { type: 'radio', name: 'wystawca', options: ['Firmowe', 'Prywatne'], tOptions: ['Oferty firmowe', 'Oferty prywatne'] }
export default wystawca